// extracted by mini-css-extract-plugin
export default {"link":"Navbar_link__MQaQK","perfil":"Navbar_perfil__FihOG","logOut":"Navbar_logOut__yqzsd","nombre":"Navbar_nombre__Xrqwn","menu":"Navbar_menu__qbpYz"};